import React from 'react';
import { useGetInactiveFamiliesQuery } from "../../api/mentorAPI";



export const InactiveFamiliesList: React.FC = () => {
  const { data: families = [], isLoading, isError } = useGetInactiveFamiliesQuery();

  return (
    <div className="flex flex-col justify-center items-center min-h-[200px] px-4">
      <h2 className="text-2xl font-bold text-primary mb-2">
        משפחות שלא נפגשו בחודש האחרון
      </h2>
      <div className="overflow-y-auto flex-1 pr-1 space-y-2">
        {isLoading ? (
          <p className="text-sm text-gray-500">טוען משפחות...</p>
        ) : isError ? (
          <p className="text-sm text-red-600">שגיאה בטעינת המשפחות</p>
        ) : families.length === 0 ? (
          <p className="text-sm text-gray-500">כל המשפחות נפגשו החודש 🎉</p>
        ) : (
          families.map((family) => (
            <div
              key={family.id}
              className="bg-gray-50 p-2 rounded flex justify-between items-center text-sm text-gray-700 hover:bg-gray-100"
            >
              <span className="font-medium">{family.familyName}</span>
              <span className="text-xs text-gray-500">
                {family.lastMeetingDate
                  ? `פגישה אחרונה: ${family.lastMeetingDate}`
                  : 'לא נפגשו אף פעם'}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

